import ServerConnectorService from './server-connector.service'
import initServerConnectorConstants from './constants'
import ClientRegistrationService from './clinet-registration.service';
import LoginService from './login.service'
import ResourceService from './resource.service'
import PasswordResetService from './password-reset.service'
import ProfileService from './profile.service'
import InstalatorRegistrationService from './instalator-registration.service'

let serverConnector = angular.module('ff.serverConnector', []);
serverConnector.factory('ServerConnectorService', ServerConnectorService);
serverConnector.factory('ClientRegistrationService', ClientRegistrationService);
serverConnector.factory('LoginService', LoginService);
serverConnector.factory('ResourceService', ResourceService);
serverConnector.factory('PasswordResetService', PasswordResetService);
serverConnector.factory('ProfileService', ProfileService);
serverConnector.factory('InstalatorRegistrationService', InstalatorRegistrationService);
initServerConnectorConstants(serverConnector);

export default serverConnector = serverConnector.name


// WEBPACK FOOTER //
// ./src/service/server-connector/server-connector.module.js